module.exports = __webpack_public_path__ + "static/media/ic_orderedlist.8795bcee.svg";